import { useRouter } from '@hum/api';
import { Spinner } from '@hum/ui-library';
import React, { useEffect } from 'react';

export const V2Redirect = ({
  to = '/',
  returnTo,
}: {
  to?: string;
  returnTo?: string;
}) => {
  useEffect(() => {
    window.location.assign(
      `${process.env.V2_BASE_URL}${to}${
        returnTo ? `?returnTo=${returnTo}` : ''
      }`
    );
  }, [to, returnTo]);

  return <Spinner fullScreen />;
};

export const V2RedirectWithPath = () => {
  const router = useRouter();

  useEffect(() => {
    window.location.assign(
      `${process.env.V2_BASE_URL}/${router.pathname}${window.location.search}`
    );
  }, [router.pathname]);

  return <Spinner fullScreen />;
};
